import deepmerge from 'deepmerge';
import * as setup from 'setup';

export function compose(...rest: any[]) {
    return (x: any) => rest.reduceRight((y, f) => f(y), x);
}

export function deepClone<T>(source: T) {
    return deepmerge<T>({}, source);
}

export function getRandomTruckName() {
    const { truckNames } = setup.game;
    return truckNames[Math.round(Math.random() * truckNames.length - 1)];
}

export function getTime() {
    return new Date().getTime();
}

export function getPathname(asPath: string): string {
    const pathWithoutHash = asPath.split('#')[0] || '/';
    const pathWithoutQuery = pathWithoutHash.split('?')[0] || '/';
    return pathWithoutQuery || '/';
}

export function getUrl(path: string) {
    if (path.startsWith('http')) {
        return path;
    }
    return `${process.env.NEXT_CONFIG_BASE_PATH || ''}${path}`;
}

export function getKromaticSiteOriginForHost(hostname?: string | null): string | null {
    const host = (hostname || '').toLowerCase();

    if (host === 'staging.kromatic.com') {
        return 'https://staging.kromatic.com';
    }

    if (host === 'kromatic.com' || host === 'www.kromatic.com') {
        return 'https://kromatic.com';
    }

    return null;
}

export function resolveKromaticSiteUrl(url: string, runtimeHostname?: string): string {
    if (!url) {
        return url;
    }

    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return url;
    }

    const host = parsed.hostname.toLowerCase();
    const isKnownKromaticHost =
        host === 'kromatic.com' || host === 'www.kromatic.com' || host === 'staging.kromatic.com';
    if (!isKnownKromaticHost) {
        return url;
    }

    const resolvedOrigin = getKromaticSiteOriginForHost(
        runtimeHostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
    );
    if (!resolvedOrigin) {
        return url;
    }

    const target = new URL(resolvedOrigin);
    parsed.protocol = target.protocol;
    parsed.host = target.host;
    return parsed.toString();
}

export function validateEmail(email: string) {
    return /^.+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.exec(email);
}
